import QuestionItemBody from "pages/ManagementPage/questionSection/questionItemCard/QuestionItemBody/QuestionItemBody";

export default QuestionItemBody;
